import { validarData } from "./date";

export const ruleDataInvalida = async (_:any, value:string) => {
    if (value === '__/__/____' || value === '' || value === undefined) {
        return Promise.resolve();
    }
    if (validarData(value)) {
        return Promise.resolve();
    }
    return Promise.reject('Data inválida!');
}

